import { Divider } from "antd";
import React from "react";

const ContentPanel = ({ dividerOrientation = "left", children = "", title = "" }) => {

    return (
        <div className="content-panel">
            {title && <Divider className={"content-panel-divier"} orientation={dividerOrientation}>{title}</Divider>}
            {children ? <div className="content-panel-children">{children}</div> : ""}
        </div>
    )
}

export default ContentPanel;